var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "power-add-dialog" }, [
    _c(
      "div",
      { staticClass: "dialog-body" },
      [
        _c(
          "el-form",
          {
            ref: "formPower",
            staticStyle: {
              display: "flex",
              "flex-wrap": "wrap",
              "justify-content": "space-between"
            },
            attrs: {
              "label-position": "top",
              model: _vm.formPower,
              rules: _vm.rules,
              "label-width": "120px"
            }
          },
          [
            _c(
              "el-form-item",
              {
                staticStyle: { height: "60px", "margin-bottom": "20px" },
                attrs: { label: "系统名称", prop: "systemId" }
              },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      size: "small",
                      disabled: _vm.ifAddEdit,
                      placeholder: "请选择系统名称"
                    },
                    model: {
                      value: _vm.formPower.systemId,
                      callback: function($$v) {
                        _vm.$set(_vm.formPower, "systemId", $$v)
                      },
                      expression: "formPower.systemId"
                    }
                  },
                  _vm._l(_vm.AddformData[0].selectData, function(option, i) {
                    return _c("el-option", {
                      key: i,
                      attrs: {
                        label: option.systemName,
                        value: option.systemId
                      }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                staticStyle: { height: "60px", "margin-bottom": "20px" },
                attrs: { label: "权限编号", prop: "permissionId" }
              },
              [
                _c("el-input", {
                  staticClass: "limit32",
                  attrs: {
                    size: "small",
                    maxlength: "32",
                    "show-word-limit": "",
                    placeholder: "请输入权限编号",
                    disabled: _vm.ifAddEdit
                  },
                  model: {
                    value: _vm.formPower.permissionId,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.formPower,
                        "permissionId",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formPower.permissionId"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                staticStyle: { height: "60px", "margin-bottom": "20px" },
                attrs: { label: "权限名称", prop: "permissionName" }
              },
              [
                _c("el-input", {
                  staticClass: "limit256",
                  attrs: {
                    size: "small",
                    maxlength: "256",
                    "show-word-limit": "",
                    placeholder: "请输入权限名称"
                  },
                  model: {
                    value: _vm.formPower.permissionName,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.formPower,
                        "permissionName",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formPower.permissionName"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "权限类型", prop: "permissionType" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: { size: "small", placeholder: "请选择权限类型" },
                    model: {
                      value: _vm.formPower.permissionType,
                      callback: function($$v) {
                        _vm.$set(_vm.formPower, "permissionType", $$v)
                      },
                      expression: "formPower.permissionType"
                    }
                  },
                  _vm._l(_vm.AddformData[1].selectData, function(option, i) {
                    return _c("el-option", {
                      key: i,
                      attrs: { label: option.value, value: option.key }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _vm.ifAddEdit
              ? _c(
                  "el-form-item",
                  { attrs: { label: "权限状态", prop: "permissionStatus" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { size: "small", placeholder: "请选择权限状态" },
                        model: {
                          value: _vm.formPower.permissionStatus,
                          callback: function($$v) {
                            _vm.$set(_vm.formPower, "permissionStatus", $$v)
                          },
                          expression: "formPower.permissionStatus"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "有效", value: "VALID" }
                        }),
                        _c("el-option", {
                          attrs: { label: "失效", value: "INVALID" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-form-item",
              {
                staticStyle: { width: "100%" },
                attrs: { label: "权限描述", prop: "permissionDesc" }
              },
              [
                _c("el-input", {
                  staticClass: "limit256",
                  attrs: {
                    size: "small",
                    type: "textarea",
                    placeholder: "请输入权限描述",
                    maxlength: "256",
                    "show-word-limit": ""
                  },
                  model: {
                    value: _vm.formPower.permissionDesc,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.formPower,
                        "permissionDesc",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formPower.permissionDesc"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "dialog-footer" },
      [
        _c(
          "el-button",
          {
            staticStyle: { "margin-right": "20px" },
            on: { click: _vm.cancelDailog }
          },
          [_vm._v("取消")]
        ),
        _c(
          "el-popconfirm",
          {
            attrs: {
              title: _vm.ifAddEdit ? "确认修改此权限？" : "确认添加此权限？"
            },
            on: {
              onConfirm: function($event) {
                return _vm.confirmsure(true)
              },
              onCancel: function($event) {
                return _vm.confirmsure(false)
              }
            }
          },
          [
            _c(
              "el-button",
              {
                attrs: { slot: "reference", type: "primary" },
                slot: "reference"
              },
              [_vm._v("确认")]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }